import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api';
import HrnbForm from '../components/controls/HrnbForm';
import HrnbFormControl from '../components/controls/HrnbFormControl';
import HrnbButton from '../components/controls/HrnbButton';
import { SendIcon } from '../icons';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!email.trim()) {
            setError('Введите email');
            return;
        }

        setLoading(true);
        try {
            const resp = await authApi.forgotPassword(email.trim());
            setMessage(resp.message || 'Ссылка для восстановления отправлена на ваш email');
            setEmail('');
        } catch (err) {
            setError(err?.response?.data?.message || err?.message || 'Ошибка отправки запроса');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container" style={{ maxWidth: 480, margin: '40px auto' }}>
            <h2>Восстановление пароля</h2>
            <HrnbForm onSubmit={handleSubmit}>
                <HrnbFormControl
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Введите ваш email"
                    autoFocus
                />
                {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
                {message && <div style={{ color: 'green', marginTop: 12 }}>{message}</div>}
                <HrnbButton
                    type="submit"
                    style={{ width: '100%', marginTop: 20 }}
                    disabled={loading}
                    icon={<SendIcon />}
                >
                    {loading ? 'Отправка...' : 'Отправить ссылку'}
                </HrnbButton>
            </HrnbForm>
            <div style={{ marginTop: 16, textAlign: 'center' }}>
                <Link to="/login">Вернуться к входу</Link>
            </div>
        </div>
    );
}
